/* KALUP - 3D spinning header logo.
   Stacks copies of the logo behind itself to give it real thickness,
   adds a readable back face and a shine that follows the letters.
   Styles: assets/kalup-logo3d.css. Remove both files' tags from
   snippets/kalup-refresh-head.liquid to turn the effect off. */
(function () {
  /* thickness in px - fewer layers on phones to keep scrolling smooth */
  var LAYERS = window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 4 : 8;

  function build(root) {
    var wraps = (root || document).querySelectorAll('.header__heading-logo-wrapper');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.classList.contains('kl3d')) return;
      var img = wrap.querySelector('img.header__heading-logo');
      if (!img) return;

      var frag = document.createDocumentFragment();
      for (var i = 1; i <= LAYERS; i++) {
        var layer = img.cloneNode(false);
        layer.removeAttribute('id');
        layer.removeAttribute('fetchpriority');
        layer.setAttribute('alt', '');
        layer.setAttribute('aria-hidden', 'true');
        layer.setAttribute('loading', 'eager');
        layer.classList.add('kl3d-layer');
        if (i === LAYERS) layer.classList.add('kl3d-back');
        layer.style.setProperty('--kl3d-z', String(-i));
        frag.appendChild(layer);
      }

      var shine = document.createElement('span');
      shine.className = 'kl3d-shine';
      shine.setAttribute('aria-hidden', 'true');
      shine.style.setProperty('--kl3d-mask', 'url("' + (img.currentSrc || img.src) + '")');
      frag.appendChild(shine);

      wrap.appendChild(frag);
      wrap.classList.add('kl3d');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { build(); });
  } else {
    build();
  }

  /* Theme editor re-renders the header section */
  document.addEventListener('shopify:section:load', function (event) { build(event.target); });
})();